import React from 'react'
import PropTypes from 'prop-types'
import styles from './FileReplacePage.scss'
import ConfirmButton from '../../components/ConfirmButton'
import { Link } from 'react-router-dom'
import FileCountBadge from '../../components/FileCountBadge'
import Upload from '../../components/Upload'
import { Button, Form, Alert, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

const getAcceptValue = isImage => {
  let acceptValue = [
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.pdf',
    '.xls',
    '.xlsx',
    '.csv',
    '.txt',
    '.zip',
    '.html'
  ].join(', ')
  if (isImage) {
    acceptValue = 'image/*'
  }
  return acceptValue
}

const FileReplacePage = props =>
  <div className={styles.FileReplacePage}>

    <a href='#' onClick={props.onGoBack}>Back to files</a>

    {!props.file.location && !props.errorLoadingFile && <div>Loading file ...</div>}
    {props.errorLoadingFile && <div>File not found 😒</div>}
    {props.file.location && <Row>
      <Col className={styles.info}>
        {
          props.isImage
          ? <a href={props.file.location} target='_blank'><img className={styles.image} src={`${props.file.location}?${props.fileHash}`} alt={props.file.location} /></a>
          : <a target='_blank' href={props.file.location}>{props.file.location}</a>
        }

        <h2><a href={props.file.location} target='_blank'>{props.file.originalName}</a></h2>
        { (props.file.fileCount > 0)
          ? <div>File referenced {props.file.fileCount} times, by:
            {
              props.file.pages && props.file.pages.map(page =>
                <div key={page.id}>
                  <Link to={`/pages/edit/${page.id}`}>
                    {page.path}</Link>
                  {' '}<FileCountBadge count={page.fileCount} />
                </div>
              )
            }
          </div>
          : <div>File not referenced by any pages.</div>
        }
      </Col>
    </Row>}

    <hr />

    {!props.errorLoadingFile && <Row>
      <Col>
        <Button onClick={props.toggleReplaceModal}>Replace</Button>
        {' '}
        <ConfirmButton title='Delete File' onConfirm={props.onDeleteFile}
          message='Are you sure you want to delete this file?'
          color='danger'>Delete</ConfirmButton>
      </Col>
    </Row>}

    <Modal isOpen={props.replaceModalIsOpen} toggle={props.toggleReplaceModal} zIndex={2000}>
      <ModalHeader toggle={props.toggleReplaceModal}>Replace File</ModalHeader>
      <ModalBody>
        <Form name='FileReplaceForm' onKeyDown={props.onKeyDown}>
          <Row>
            <Col>
              {
                props.errorLoadingPreview &&
                <Alert color='warning'>
                  <strong>Warning!</strong> Error loading preview of <a href={props.location} target='_blank'>{props.location}</a>
                </Alert>
              }

              {
                props.isReplacing &&
                <Alert color='info'>
                  <strong>Please wait!</strong> Replacing across {props.file.fileCount} pages, could take some time.
                </Alert>
              }

              {
                props.isLoadingPreview &&
                <div>Loading preview ...</div>
              }

              {
                props.isUploading &&
                <div>Uploading file ...</div>
              }

              {props.location && !props.isLoadingPreview && !props.errorLoadingPreview &&
              <div>
                <h4>Preview</h4>
                <div>
                  {
                    props.isImage
                    ? <img src={`${props.location}?${Date.now()}`} className={styles['image-preview']} />
                    : <span>{props.tempFile.originalName} <a target='_blank' href={props.location}>{props.location}</a></span>
                  }
                </div>
              </div>
              }
            </Col>
          </Row>
          <Row>
            <Col size='6'>
              <Upload
                getRef={() => {}}
                accept={getAcceptValue(props.isImage)}
                onFinish={props.onFinish}
                onStart={props.onStart}
                onError={props.onError}
                onFileExists={props.onFileExists}
                />
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button style={{margin: '0'}} form='FileReplaceForm' color='primary'
          type='submit' onClick={props.onSubmit}>Replace</Button>
        &nbsp;
        <Button color='secondary' onClick={props.toggleReplaceModal}>Cancel</Button>
      </ModalFooter>
    </Modal>

    {
      false &&
      <div className='debug-block'>
        <pre>{JSON.stringify(props.file, null, 4)}</pre>
      </div>
    }
  </div>

FileReplacePage.propTypes = {
  tempFile: PropTypes.object,
  file: PropTypes.object,
  fileHash: PropTypes.string,
  location: PropTypes.string,
  isLoadingPreview: PropTypes.bool,
  isImage: PropTypes.bool,
  originalName: PropTypes.string,
  isReplacing: PropTypes.bool,
  errorLoadingPreview: PropTypes.bool,
  replaceModalIsOpen: PropTypes.bool,
  toggleReplaceModal: PropTypes.func,
  onDeleteFile: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSubmit: PropTypes.func,
  isUploading: PropTypes.bool,
  errorLoadingFile: PropTypes.bool,
  onFinish: PropTypes.func,
  onStart: PropTypes.func,
  onError: PropTypes.func,
  onFileExists: PropTypes.func,
  onGoBack: PropTypes.func
}

export default FileReplacePage



// WEBPACK FOOTER //
// ./src/pages/FileReplacePage/FileReplacePage.js